module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-20"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Peace"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pz20-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ba_04",
      "id": "ab_04"
    }
  }, [_c('b', [_vm._v("Peace")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-3"
    }
  }, [_vm._v("You will keep him in perfect peace,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-4"
    }
  }, [_vm._v("Whose mind is stayed on You,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-5"
    }
  }, [_vm._v("Because he trusts in You.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz20-6"
    }
  }, [_c('em', [_vm._v("Isaiah 26:3")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-7"
    }
  }, [_vm._v("But now in Christ Jesus you who once were far off have been brought near by the blood of Christ.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-8"
    }
  }, [_vm._v("For He Himself is our peace, who has made both one, and has broken down the middle wall of separation.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz20-9"
    }
  }, [_c('em', [_vm._v("Ephesians 2:13, 14")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-10"
    }
  }, [_vm._v("Be anxious for nothing, but in everything by prayer and supplication, with thanksgiving, let your requests be made known to God;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-11"
    }
  }, [_vm._v("and the peace of God, which surpasses all understanding, will guard your hearts and minds through Christ Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz20-12"
    }
  }, [_c('em', [_vm._v("Philippians 4:6, 7")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-13"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(", You will establish peace for us,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-14"
    }
  }, [_vm._v("For You have also done all our works in us.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz20-15"
    }
  }, [_c('em', [_vm._v("Isaiah 26:12")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-1"
    }
  }, [_vm._v("For unto us a Child is born,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-2"
    }
  }, [_vm._v("Unto us a Son is given;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-3"
    }
  }, [_vm._v("And the government will be upon His shoulder.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-4"
    }
  }, [_vm._v("And His name will be called Wonderful, Counselor,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-6"
    }
  }, [_vm._v("Mighty God,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-7"
    }
  }, [_vm._v("Everlasting Father, Prince of Peace.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-8"
    }
  }, [_vm._v("Of the increase of His government and peace there will be no end,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-9"
    }
  }, [_vm._v("Upon the throne of David and over His kingdom,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-10"
    }
  }, [_vm._v("To order it and establish it with judgment and justice from that time forward, even forever.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-11"
    }
  }, [_vm._v("The zeal of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" of hosts will perform this.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz21-12"
    }
  }, [_c('em', [_vm._v("Isaiah 9:6, 7")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-13"
    }
  }, [_vm._v("And the God of peace will crush Satan under your feet shortly. The grace of our Lord Jesus Christ be with you. Amen.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz21-14"
    }
  }, [_c('em', [_vm._v("Romans 16:20")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-15"
    }
  }, [_vm._v("The things which you learned and received and heard and saw in me, these do, and the God of peace will be with you.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz21-16"
    }
  }, [_c('em', [_vm._v("Philippians 4:9")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-1"
    }
  }, [_vm._v("Therefore, having been justified by faith, we have peace with God through our Lord Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz22-2"
    }
  }, [_c('em', [_vm._v("Romans 5:1")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-3"
    }
  }, [_vm._v("And let the peace of God rule in your hearts, to which also you were called in one body; and be thankful.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz22-4"
    }
  }, [_c('em', [_vm._v("Colossians 3:15")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-5"
    }
  }, [_vm._v("I will both lie down in peace, and sleep;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-6"
    }
  }, [_vm._v("For You alone, O L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(", make me dwell in safety.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz22-7"
    }
  }, [_c('em', [_vm._v("Psalm 4:8")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-8"
    }
  }, [_vm._v("The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" will give strength to His people;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-9"
    }
  }, [_vm._v("The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" will bless His people with peace.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz22-10"
    }
  }, [_c('em', [_vm._v("Psalm 29:11")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-11"
    }
  }, [_vm._v("Peace I leave with you, My peace I give to you; not as the world gives do I give to you. Let not your heart be troubled, neither let it be afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz22-12"
    }
  }, [_c('em', [_vm._v("John 14:27")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7c7e56c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter04.vue
// module id = 84
// module chunks = 0